<div
  class="rounded"
  style="background-color: white !important; height: fit-content"
  [ngStyle]="{ 'max-width': filteredView ? '82vw' : '' }"
>
  <div
    class="pt-5 pl-5 pr-5"
    style="
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-content: center;
    "
  >
    <ng-container>
      <div class="card-toolbar">
        <a
          class="btn btn-icon btn-sm btn-clean mr-2"
          [class.active]="showCampaign"
          (click)="showCampaignOnClick()"
        >
          <span
            class="svg-icon svg-icon-2x"
            [class.svg-icon-light]="showList"
            [class.svg-icon-primary]="showCampaign"
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              version="1.1"
            >
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <rect x="0" y="0" width="24" height="24" />
                <rect fill="#000000" x="5" y="4" width="6" height="16" rx="1.5" />
                <rect fill="#000000" opacity="0.3" x="13" y="4" width="6" height="16" rx="1.5" />
              </g>
            </svg>
          </span>
        </a>
        <a
          class="btn btn-icon btn-sm btn-clean draggable-handle mr-2"
          [class.active]="showList"
          (click)="showListOnClick()"
        >
          <span
            class="svg-icon svg-icon-primary svg-icon-2x"
            [class.svg-icon-light]="showCampaign"
            [class.svg-icon-primary]="showList"
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              version="1.1"
            >
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <rect x="0" y="0" width="24" height="24" />
                <rect fill="#000000" opacity="0.3" x="4" y="5" width="16" height="6" rx="1.5" />
                <rect fill="#000000" x="4" y="13" width="16" height="6" rx="1.5" />
              </g>
            </svg>
          </span>
        </a>
      </div>
    </ng-container>
    <ng-container>
      <div class="" style="text-align: right" *ngIf="!readOnly">
        <ng-template ngxPermissionsOnly="canCreateWorkflowFromStart">
          <button
            class="btn btn-primary text-weight-bold"
            type="button"
            (click)="openAddFlowModal()"
            mat-raised-button
            matTooltip="Create workflow"
          >
            <i class="flaticon2-add-1"></i>
            New workflow
          </button>
        </ng-template>
      </div>
    </ng-container>
    <div *ngIf="!readOnly" class="d-flex">
      <div class="dropright mr-2">
        <button
          mat-raised-button
          data-toggle="dropdown"
          class="btn btn-sm btn-primary dropdown-toggle px-4"
        >
          {{ 'DIALOG.ASSIGN.LABEL' | translate }}
          <i class="ki ki-arrow-down icon-sm ml-2"></i>
        </button>
        <div
          class="dropdown-menu dropdown-menu-anim-up dropdown-menu-sm dropdown-menu-right px-4 py-2"
        >
          <div class="bg-hover-light p-2" (click)="assign('STANDARD')">
            {{ 'DIALOG.ASSIGN.STANDARD' | translate }}
          </div>
          <div class="bg-hover-light p-2" (click)="assign('RESOURCE')">
            {{ 'DIALOG.ASSIGN.RESOURCE' | translate }}
          </div>
          <div class="bg-hover-light p-2" (click)="assign('BLOCKER')">
            {{ 'DIALOG.ASSIGN.BLOCKER' | translate }}
          </div>
        </div>
      </div>
      <kt-workflow-filter
        (filterChange)="filterChanges($event)"
        [statusList]="statusList"
        [categoryList]="categoryList"
        [icon]="'./assets/media/svg/icons/General/Search.svg'"
        [useSVG]="true"
      ></kt-workflow-filter>
    </div>
  </div>

  <div
    *ngIf="showCampaign && !reload"
    class="p-5"
    style="margin-bottom: 50px; overflow-x: auto; height: calc(100% - 49px)"
  >
    <kt-workflow-status-column
      class="workflow-status-column"
      *ngFor="let status of workflowStatusesList"
      [filteredView]="filteredView"
      [workflowGroupIdFromFilteredView]="workflowGroupIdFromFilteredView"
      [entitiesFromFilterView]="entitiesFromFilterView"
      [status]="status"
      [statusesList]="statusesList"
      [filters]="filters"
      (refreshWorkflowListAll)="refreshWorkflowList()"
    >
    </kt-workflow-status-column>
  </div>

  <div style="height: 100%; box-sizing: border-box">
    <kt-workflow-accordion-dashboard
      *ngIf="showList"
      [statusesList]="statusesList"
      [filters]="filters"
      [filteredView]="filteredView"
      [workflowGroupIdFromFilteredView]="workflowGroupIdFromFilteredView"
      [entitiesFromFilterView]="entitiesFromFilterView"
    ></kt-workflow-accordion-dashboard>
  </div>
</div>
